export const createGigsSkeleton = (amount) => Array(...Array(amount)).map((_, i) => ({ id: i }));
